export const ROOT_SLICE_SURVEYS_NO_READINGS = 'DITSurveysNoReadings';
